import styled from 'styled-components';

interface PhaseOptionContainerProps {
  isSelected: boolean;
}

interface ButtonProps {
  disabled?: boolean;
  $fullWidth?: boolean;
}

export const PhaseOptionContainer = styled.div.attrs({
  className: 'PhaseOptionContainer',
})<PhaseOptionContainerProps>(
  ({ isSelected }) => `
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0.75em 1em;
    cursor: pointer;
    font-size: 12px;
    background: ${isSelected ? 'lightpink' : 'none'};
    &:hover {
      background: ${isSelected ? 'pink' : 'lightgray'};
    }
  `
);

export const ActionsContainer = styled.div.attrs({
  className: 'ActionsContainer',
})`
  background: transparent;
  display: flex;
  flex-direction: column;
  width: calc(100% - 20px);
  height: 100%;
  gap: 10px;
  border-radius: 5px;
  padding: 0 10px;
  margin: 0 10px;
  box-sizing: border-box;
  justify-content: center;
`;

export const Button = styled.div.attrs({
  className: 'Button',
})<ButtonProps & { editMode?: boolean }>(
  ({ disabled, editMode, $fullWidth }) => `
    background: ${disabled ? 'none' : editMode ? '#1d7bbf' : '#2A98E8'};
    color: ${disabled ? '#999' : '#FFF'};
    border-radius: 5px;
    height: 32px;
    width: ${$fullWidth ? '100%' : 'calc(50% - 5px)'};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ${disabled ? 'default' : 'pointer'};
    border: ${editMode ? '2px solid white' : 'none'}; /* Add border for edit mode */
    &:hover {
      background: ${disabled ? 'none' : editMode ? '#1d7bbf' : '#2A98E8'}; 
      opacity: ${disabled ? 1 : 0.7};
    }  
  `
);

interface ButtonsContainerProps {
  align?: string;
  justify?: string;
}

interface DismissalSlideProps {
  $isOpen: boolean;
}

export const ButtonsContainer = styled.div.attrs<ButtonsContainerProps>(() => ({
  className: 'ButtonsContainer',
}))<ButtonsContainerProps>`
  display: flex;
  align-items: ${props => props.align};
  justify-content: ${props => props.justify};
`;

export const DismissalContainer = styled.div<DismissalSlideProps>`
  position: relative;
  width: ${props => (props.$isOpen ? '100%' : 'calc(50% - 5px)')};
  height: 32px;
  overflow: hidden;
`;

export const DismissalButtonPanel = styled.div<DismissalSlideProps>`
  position: absolute;
  inset: 0;
  transform: translateX(${props => (props.$isOpen ? '-100%' : '0')});
  transition: transform 220ms ease;
`;

export const DismissalCommentPanel = styled.div<DismissalSlideProps>`
  position: absolute;
  inset: 0;
  display: flex;
  gap: 6px;
  transform: translateX(${props => (props.$isOpen ? '0' : '100%')});
  transition: transform 220ms ease;
`;

export const ReviewerCommentInput = styled.input`
  min-width: 0;
  flex: 1;
  border: 1px solid #2a98e8;
  border-radius: 5px;
  padding: 0 8px;
  background: #101719;
  color: #fff;
  outline: none;
  box-shadow: none;

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &::placeholder {
    color: #999;
  }
`;

export const ConfirmDismissButton = styled.button`
  width: 32px;
  min-width: 32px;
  border: 0;
  border-radius: 5px;
  background: #2a98e8;
  color: #fff;
  font-size: 18px;
  cursor: pointer;

  &:disabled {
    background: #555;
    color: #999;
    cursor: default;
  }
`;

export const TitleContainer = styled.div.attrs({
  className: 'TitleContainer',
})`
  border-radius: 5px 10px 0 0;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
`;
